import React from 'react';
import { createRoot } from 'react-dom/client'; // React v18よりcreateRootを使う
import App from './App';

const container = document.getElementById('gmoAsk');
const root = createRoot(container);
root.render(<App />);
